import type { ProblemDetails } from "./types";

function isProblemDetails(obj: any): obj is ProblemDetails {
  return obj
    && typeof obj === 'object'
    && 'type' in obj
    && 'title' in obj
    && 'status' in obj;
}

export {
  isProblemDetails
}
